import { useVirtualizer } from '@tanstack/react-virtual'
import React from 'react'

import { getMeasureElement } from './utils'

export type ElementVirtualizerType = ReturnType<typeof useVirtualizer<HTMLDivElement, Element>>

interface ElementVirtualizerProps {
  children: (virtualizer: ElementVirtualizerType) => React.ReactNode
  estimatedRowHeight: number
  scrollElement: HTMLDivElement | null
  rowsLength: number
}

export const ElementVirtualizer = ({
  children,
  estimatedRowHeight,
  scrollElement,
  rowsLength,
}: ElementVirtualizerProps) => {
  const rowVirtualizer = useVirtualizer<HTMLDivElement, Element>({
    count: rowsLength,
    estimateSize: () => estimatedRowHeight,
    getScrollElement: () => scrollElement,
    measureElement: getMeasureElement(),
    overscan: 10,
  })

  return <>{children(rowVirtualizer)}</>
}
